import { Dispatch } from 'redux';
import { UiState } from 'store/ui/uiReducer';
import _ from 'lodash';
import { Service } from 'types/rest/assetCatalogTypes';

/**
 *  If a Service is selected in pageFilter, it returns its ID.
 *  If nothing is selected, returns Default Service ID.
 *
 *  @param fallBackToAny returns id of first available service if true
 */
export const getDefaultServiceId = (fallBackToAny?: boolean): any => {
  return (dispatch: Dispatch): number | undefined => {
    const service: Service = dispatch(getDefaultService(fallBackToAny));
    return service ? service.id : 0;
  };
};

/**
 *  If a Service is selected in pageFilter, it returns the selected service.
 *  If nothing is selected, returns Default Service.
 *
 *  @param fallBackToAny returns first available service available if set to true
 */
export const getDefaultService = (fallBackToAny?: boolean): any => {
  return (dispatch: Dispatch, getState: any): Service => {
    //Preselect Service, by default
    let service;
    const services = getState().services.services;

    // If a service is preselected in the main filter, use it
    try {
      const uiState = getState().ui as UiState;

      if (uiState.pageFilter.serviceId !== 0) {
        if (services != null && services.length > 0) {
          service = _.filter(services, (item: Service) => item.id === uiState.pageFilter.serviceId)[0];
        } else {
          throw new Error('Service defined in page filter cannot be found in list of services.');
        }
      } else {
        // If not, use Default Service instead
        if (services != null && services.length > 0) {
          service = _.filter(services, (item: Service) => item.name === 'Default Service')[0];
          if (_.isUndefined(service)) {
            throw new Error('There is no Default Service available');
          }
        }
      }
    } catch (ex) {
      console.error('Could not determine default service.', ex);
      if (services != null && services.length > 0 && fallBackToAny === true) {
        service = services[0];
      }
    }
    return service;
  };
};
